import React from 'react';
import { Colors } from '../../constants';

const TimeIcon = ({ customClass, color }) => {
  return(
    <svg width="14" height="14" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.5 16.2342C12.6421 16.2342 16 12.8702 16 8.7205C16 4.57079 12.6421 1.20679 8.5 1.20679C4.35786 1.20679 1 4.57079 1 8.7205C1 12.8702 4.35786 16.2342 8.5 16.2342Z" 
        stroke={`#${ color || Colors.black}`} 
        strokeLinecap="round" 
        strokeLinejoin="round"
        className={`svg-icon-custom ${customClass || ''}`} />
      <path d="M8.5 4.2124V8.72063L11.5 10.2234" 
        stroke={`#${ color || Colors.black }`} 
        strokeLinecap="round" 
        strokeLinejoin="round"
        className={`svg-icon-custom ${customClass || ''}`} />
    </svg>
  );
};

export default TimeIcon;